import { EmissionData } from './types'
import { formatPercentage } from '@/utils/formatPercentage'

export const groupExcessItemsAsOthers = (
    data: EmissionData[],
    maxVisibleItems: number
): EmissionData[] => {
    if (data.length <= maxVisibleItems) return data

    // Show first (maxVisibleItems - 1) items
    const visibleItems = data.slice(0, maxVisibleItems - 1)
    // Group the 7th item (index maxVisibleItems - 1) AND all remaining as "Other"
    const othersItems = data.slice(maxVisibleItems - 1)

    const parsePercentage = (percentage: string) =>
        typeof percentage === 'string'
            ? parseFloat(percentage.replace(/[^\d.-]/g, ''))
            : percentage

    const bundledPercentage = othersItems
        .map((item) => parsePercentage(item.percentage))
        .reduce((sum, val) => sum + val, 0)

    const bundledItem: EmissionData = {
        name: `Other (${String(othersItems.length)})`,
        value: othersItems.reduce((sum, item) => sum + item.value, 0),
        percentage: formatPercentage(bundledPercentage, 3),
    }

    return [...visibleItems, bundledItem]
}
